import { lazy } from "react";
import { lazyRetry } from "../../../helpers";

export default lazy(() =>
  lazyRetry(() => import("./Login"), "login-page")
);
